import React from 'react';
import { Await } from '../../../components/Await';
import { useSanity } from '../../../lib/landingPage';
import { observer } from 'mobx-react-lite';
import { Redirect, useRouteMatch } from 'react-router-dom';
import { BlogPostsPage } from './BlogPostsPage';
import { categoriesQuery } from './BlogHomePage';
import routes from '../../../pages/landingPage/routes';

export const BlogSearchPage = observer(() => {
    const sanity = useSanity();
    const match = useRouteMatch<{ searchTerm: string }>({
        path: routes.blog.search.path,
    });
    const searchTerm = match?.params.searchTerm;
    if (!searchTerm) return <Redirect to={'/'} />;
    return (
        <Await
            views={{
                categories: sanity.asyncBlog(categoriesQuery),
            }}
            resolved={BlogPostsPage}
            extra={{
                searchTerm,
                pageTitle: `Procurar: ${searchTerm}`,
            }}
        />
    );
});
